import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import ActionButton from '../shared/buttons/ActionButton';
import permissionsProvider from '../../utilities/permissionsProvider';

const UserItem = ({
    item,
    editItem,
    enableItem,
    disableItem
}) => {

    const restrictDelete = !permissionsProvider.canDelete(item.acl);
    const userType = (typeId) => {
        switch (typeId) {
            case 1:
                return 'User';
            case 2:
                return 'Manager';
            case 3:
                return 'Franchise Admin';
            case 4:
                return 'Global Admin';
        }
        return typeId;
    }

    return (
        <tr className={item.isEnabled ? '' : 'disabled-item'}>
            <CustomTd hide="md" content={item.name} />
            <CustomTd content={item.userName} />
            <CustomTd hide="md" content={userType(item.userType)} />
            {window.biztrax.franchiseId === 1 &&
                <CustomTd hide="lg" content={item.franchiseName} />
            }
            <CustomTd content={item.isEnabled ? 'Active' : 'Disabled'} />
            <CustomTd className="two-button-cell">
                <ActionButton
                    buttonText="Edit"
                    imgSource="/images/edit.svg"
                    onClick={editItem}
                />
                {item.isEnabled ?
                    (
                        <ActionButton
                            buttonText="Disable"
                            imgSource="/images/x.svg"
                            onClick={disableItem}
                            disabled={restrictDelete}
                        />
                    ) : (
                        <ActionButton
                            buttonText="Enable"
                            imgSource="/images/check.svg"
                            onClick={enableItem}
                            disabled={restrictDelete}
                        />
                    )}
            </CustomTd>
        </tr>
    );
}

export default UserItem;